// Column configuration
export const COLUMN_CONFIG = {
    select: { flex: 1, label: '' },
    productName: { flex: 3, label: 'Name' },
    productCucNumber: { flex: 2, label: 'CUC' },
    brand: { flex: 2, label: 'Brand' },
    countries: { flex: 2, label: 'Countries' },
    affected: { flex: 2, label: 'Impacted' },
    comments: { flex: 1, label: 'Info' }
};

// Labels
export const LABELS = {
    IMPACTED: 'Impacted',
    NOT_IMPACTED: 'Not Impacted',
    TO_BE_DETERMINED: 'To be Determined',
    COMMENT_DETAILS: 'Comment Details',
    CLOSE: 'Close',
    PREVIEW_COMMENT: 'Preview comment',
    NA: 'N/A',
    NO_PRODUCTS: 'No products to display.',
    ALL_PRODUCTS_PLANNED: 'All products are included in plans.',
    FILTER_BY_BRAND: 'Filter by brand',
    FILTER_BY_COUNTRY: 'Filter by country'
};

// Status types
export const STATUS_TYPES = {
    IMPACTED: 'IMPACTED',
    NOT_IMPACTED: 'NOT_IMPACTED',
    TO_BE_DETERMINED: 'TO_BE_DETERMINED'
};

// UI constants
export const UI_CONSTANTS = {
    MAX_HEIGHT: '60vh',
    ICON_SIZE: '1.3rem',
    FONT_SIZES: {
        HEADER: '0.8rem',
        CELL: '0.9rem',
        SMALL: '0.85rem',
        NA: '0.6rem'
    },
    ICON_BUTTON: {
        PADDING: 0.5,
        MIN_WIDTH: '16px',
        HEIGHT: '16px'
    }
};

// Default values
export const DEFAULTS = {
    EMPTY_CUC: '—'
};